let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("k56jx")).then(() => parcelRequire('8PU9Z'));